import { $host } from './fetch';

const normalizeError = (error) => {
    if (error?.response?.data) {
        return {
            status: error.response.status,
            code: error.response.data.code || 'UNKNOWN_ERROR',
            message: error.response.data.message || 'Server error',
            retry_after_seconds: error.response.data.retry_after_seconds
        };
    }

    if (error?.request) {
        return {
            status: null,
            code: 'NETWORK_ERROR',
            message: 'Server is not responding'
        };
    }

    return {
        status: null,
        code: 'UNEXPECTED_ERROR',
        message: error?.message || 'Unexpected error'
    };
};

export const accessSupportChat = async (chatId, email, page = 1, limit = 30) => {
    try {
        const { data } = await $host.post('supportchat/access', {
            chat_id: chatId,
            email,
            page,
            limit
        });

        return data;
    } catch (error) {
        throw normalizeError(error);
    }
};

export const sendSupportMessage = async (chatId, email, message) => {
    try {
        const { data } = await $host.post('supportchat/send', {
            chat_id: chatId,
            email,
            message
        });

        return data;
    } catch (error) {
        throw normalizeError(error);
    }
};
